/* maks-modele-pasek: skrypty sekcji przeniesione z pliku sekcji. Uruchamiaja wszystkie
   kopie sekcji na stronie. */
;(function () {
  var setup = function (root) {
    if (root.getAttribute('data-mp-ready') === '1') return;
    root.setAttribute('data-mp-ready', '1');
    if (root.getAttribute('data-mp-reveal') !== '1') return;

    var rail = root.querySelector('[data-mp-rail]');
    if (!rail) return;

    var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    if (mq && mq.matches) return;

    var natywne = !!(window.CSS && CSS.supports && CSS.supports('animation-timeline', 'view()'));
    if (natywne) return;

    rail.classList.add('is-reveal');

    var show = function () {
      rail.classList.add('is-in');
      window.setTimeout(function () {
        rail.classList.remove('is-in');
        rail.classList.remove('is-reveal');
      }, 1400);
    };

    if (!('IntersectionObserver' in window)) { show(); return; }

    var io = new IntersectionObserver(function (entries) {
      for (var j = 0; j < entries.length; j++) {
        if (entries[j].isIntersecting) { show(); io.disconnect(); return; }
      }
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

    io.observe(rail);
  };

  var boot = function (scope) {
    var nodes = (scope || document).querySelectorAll('[data-maks-mp]');
    for (var i = 0; i < nodes.length; i++) setup(nodes[i]);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
;(function () {
  var start = function (root) {
    if (root.getAttribute('data-mp-on') === '1') return;
    root.setAttribute('data-mp-on', '1');
    var rail = root.querySelector('[data-mp-rail]');
    var track = rail && rail.querySelector('.mp-track');
    var prev = root.querySelector('[data-mp-prev]');
    var next = root.querySelector('[data-mp-next]');
    if (!rail || !track) return;
    var petla = root.getAttribute('data-mp-loop') === '1';
    var calm = window.matchMedia('(prefers-reduced-motion: reduce)');
    var polowa = 0;
    var jedzie = false;

    var klonuj = function () {
      if (!petla || track.getAttribute('data-klon') === '1') return;
      if (rail.scrollWidth <= rail.clientWidth + 4) return;
      var org = [].slice.call(track.children);
      if (!org.length) return;
      track.setAttribute('data-klon', '1');
      // klony nie moga odziedziczyc stanu ukrycia z animacji wjazdu
      rail.classList.remove('is-reveal');
      rail.classList.add('is-in');
      for (var i = 0; i < org.length; i++) {
        var k = org[i].cloneNode(true);
        k.setAttribute('aria-hidden', 'true');
        k.setAttribute('tabindex', '-1');
        k.removeAttribute('id');
        track.appendChild(k);
      }
    };

    var mierz = function () {
      polowa = track.getAttribute('data-klon') === '1' ? track.scrollWidth / 2 : 0;
    };

    var pilnuj = function () {
      if (!polowa) return;
      if (rail.scrollLeft >= polowa) rail.scrollLeft -= polowa;
    };

    var rafId = null;
    var wartownik = null;

    var przerwij = function () {
      if (rafId) { window.cancelAnimationFrame(rafId); rafId = null; }
      if (wartownik) { window.clearTimeout(wartownik); wartownik = null; }
      jedzie = false;
    };

    var anim = function (cel) {
      przerwij();
      if (calm.matches) { rail.scrollLeft = cel; pilnuj(); return; }
      var od = rail.scrollLeft;
      var dyst = cel - od;
      if (!dyst) return;
      var t0 = null;
      var czas = 620;
      jedzie = true;
      wartownik = window.setTimeout(function () { przerwij(); pilnuj(); }, czas + 200);
      var krok = function (ts) {
        if (t0 === null) t0 = ts;
        var p = (ts - t0) / czas;
        if (p > 1) p = 1;
        var e = p === 1 ? 1 : 1 - Math.pow(2, -10 * p);
        rail.scrollLeft = od + dyst * e;
        if (p < 1) { rafId = window.requestAnimationFrame(krok); }
        else { przerwij(); pilnuj(); }
      };
      rafId = window.requestAnimationFrame(krok);
    };

    var wciecie = function () {
      return parseFloat(window.getComputedStyle(rail).paddingLeft) || 0;
    };

    var poz = function (el) {
      return el.getBoundingClientRect().left - rail.getBoundingClientRect().left + rail.scrollLeft;
    };

    var przyciagnij = function (x, pad) {
      var d = track.children;
      var best = 0;
      for (var i = 0; i < d.length; i++) {
        var p = poz(d[i]) - pad;
        if (p <= x + 1) { best = p; } else { break; }
      }
      return best;
    };

    var idz = function (kier) {
      mierz();
      var d = track.children;
      if (!d.length) return;
      var pad = wciecie();
      var wid = rail.clientWidth;
      var lewa = rail.scrollLeft;
      var cel = null;
      if (kier > 0) {
        for (var i = 0; i < d.length; i++) {
          var p = poz(d[i]);
          if (p + d[i].offsetWidth > lewa + wid + 1) { cel = p - pad; break; }
        }
        if (cel === null) { cel = lewa + wid; }
      } else {
        cel = przyciagnij(lewa - wid + pad, pad);
        if (cel >= lewa - 1) { cel = lewa - wid; }
      }
      if (cel < 0) {
        if (polowa) { rail.scrollLeft += polowa; cel += polowa; }
        else { cel = 0; }
      }
      anim(cel);
    };

    if (prev) prev.addEventListener('click', function () { idz(-1); });
    if (next) next.addEventListener('click', function () { idz(1); });
    ['wheel', 'touchstart', 'pointerdown'].forEach(function (zd) {
      rail.addEventListener(zd, przerwij, { passive: true });
    });
    rail.addEventListener('scroll', function () { if (!jedzie) pilnuj(); }, { passive: true });

    var odswiez = function () { klonuj(); mierz(); };
    odswiez();
    if (window.ResizeObserver) { new ResizeObserver(odswiez).observe(rail); }
    else { window.addEventListener('resize', odswiez); }
    window.setTimeout(odswiez, 600);
  };

  /* Karuzele ponizej pierwszego ekranu uruchamiamy dopiero, gdy przewijanie
     zbliza sie do nich (800 px zapasu), zamiast wszystkich naraz przy wczytaniu
     strony. Te widoczne od razu startuja tak jak wczesniej. */
  var wkrotce = function (el, fn) {
    if (!('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) { fn(el); return; }
    if (el.getBoundingClientRect().top < (window.innerHeight || 800) * 1.5) { fn(el); return; }
    var io = new IntersectionObserver(function (wpisy) {
      for (var j = 0; j < wpisy.length; j++) {
        if (wpisy[j].isIntersecting) { io.disconnect(); fn(el); return; }
      }
    }, { rootMargin: '800px 0px' });
    io.observe(el);
  };
  var boot = function (scope) {
    var n = (scope || document).querySelectorAll('[data-mp-car]');
    for (var i = 0; i < n.length; i++) wkrotce(n[i], start);
  };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { boot(document); }); }
  else { boot(document); }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
}());
